// namespace (소문자)
export const NAMESPACE = 'area';
//actions
export const FETCH_CURRENT = 'FETCH_CURRENT';
export const FETCH_DONG = 'FETCH_DONG';
export const FETCH_NEARBY = 'FETCH_NEARBY';
export const FETCH_SELECTED_NEARBY = 'FETCH_SELECTED_NEARBY';
export const UPDATE_REGION = 'UPDATE_REGION';

//mutations
export const SET_AREA = 'SET_AREA';
export const SET_MY_AREA = 'SET_MY_AREA';

//state
export const AREA_RESET_STATE = 'AREA_RESET_STATE';
